import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'uvp',
  standalone: true,
})
export class UvpPipe implements PipeTransform {
  transform(value?: number): string {
    if (!value) {
      return '';
    }
    return value.toLocaleString('de', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      currencyDisplay: 'symbol',
    });
  }
}
